import { render, staticRenderFns } from "./NavigationClickArea.vue?vue&type=template&id=dcd58d78&"
import script from "./NavigationClickArea.vue?vue&type=script&lang=js&"
export * from "./NavigationClickArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports